var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTimelineWeek = function SvgTimelineWeek(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "timeline-week_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#timeline-week_svg__a)",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#timeline-week_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M0 0h40v40H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "timeline-week_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#timeline-week_svg__c",
    transform: "scale(.0119)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "timeline-week_svg__c",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,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"
  }))));
};

export default SvgTimelineWeek;